import { css } from '@understory-io/leaf/css';
import { Text } from '@understory-io/leaf/text';

type PreviewBannerProps = {
  companyName?: string;
  fqdn?: string;
};

/**
 * Small banner shown only on Vercel preview deployments so reviewers can see
 * which tenant is currently being rendered. The `?host=` override is
 * persisted via [[preview-host-cookie]], and an empty `?host=` clears it.
 */
export function PreviewBanner({ companyName, fqdn }: PreviewBannerProps) {
  return (
    <div
      className={css({
        position: 'sticky',
        top: '[0]',
        zIndex: '[200]',
        background: 'surface.accent',
        color: 'content.onaccent',
        paddingY: 'micro',
        paddingX: 'small',
        display: 'flex',
        gap: 'small',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        textAlign: 'center',
      })}
    >
      <Text style="body-small-bold">Preview</Text>
      <Text style="body-small-regular">
        {companyName ? `${companyName} — ` : ''}
        {fqdn ?? 'unknown storefront'}
      </Text>
      <a
        href="?host="
        className={css({
          textStyle: 'body-small-regular',
          textDecoration: 'underline',
        })}
      >
        Reset
      </a>
    </div>
  );
}
